export const slr = {
  name: `slr`,
  sql: `
    SELECT * FROM solano_slr
    WHERE haz_slr IN ('Low','Intermediate Low','Intermediate','Intermediate High','High','Extreme')
    `,
  cartoCSS: `
    #layer {
      polygon-fill: ramp([haz_slr], (#FF6400, #FF9933, #FFCC66, #FF66FF, #CC00CC, #660066), ("Low", "Intermediate Low", "Intermediate", "Intermediate High", "High", "Extreme"), =);
      polygon-opacity: 0.58;
      polygon-comp-op: overlay;
    }
    #layer::outline {
      line-width: 0;
      line-color: #FFFFFF;
      line-opacity: 0.0;
    }
  `,
}